import React from 'react';
import {
  AuthSplitLayout, AuthBadge, AuthTitle, AuthDesc, AuthButton, BRAND, AMBER,
} from 'components/auth';
import { useNavigate } from 'components/lib';

// ── Illustration: bus perdido en ruta ─────────────────────────────────────────

function LostBusIllustration() {
  return (
    <svg viewBox="0 0 400 300" fill="none" xmlns="http://www.w3.org/2000/svg"
      style={{ width: '100%', maxWidth: 340, display: 'block' }}>

      {/* Fondo circular */}
      <path d="M 200,4 C 306,4 396,68 396,150 C 396,232 306,296 200,296 C 94,296 4,232 4,150 C 4,68 94,4 200,4 Z"
        fill={AMBER} fillOpacity="0.18" />

      {/* Carretera */}
      <rect x="60" y="190" width="280" height="38" rx="6" fill={BRAND} opacity="0.08" />
      <rect x="60" y="190" width="280" height="38" rx="6" stroke={BRAND} strokeWidth="1.5" opacity="0.12" />
      {/* Líneas de carretera */}
      <rect x="112" y="205" width="30" height="8" rx="3" fill="white" opacity="0.55" />
      <rect x="184" y="205" width="30" height="8" rx="3" fill="white" opacity="0.55" />
      <rect x="256" y="205" width="30" height="8" rx="3" fill="white" opacity="0.55" />

      {/* Bus principal */}
      <rect x="130" y="120" width="140" height="76" rx="12" fill={BRAND} />
      <rect x="130" y="120" width="140" height="76" rx="12" stroke={AMBER} strokeWidth="2" opacity="0.6" />

      {/* Ventanas del bus */}
      <rect x="144" y="132" width="28" height="20" rx="5" fill={AMBER} opacity="0.80" />
      <rect x="182" y="132" width="28" height="20" rx="5" fill={AMBER} opacity="0.80" />
      <rect x="220" y="132" width="28" height="20" rx="5" fill={AMBER} opacity="0.80" />
      <rect x="143" y="158" width="126" height="4" rx="2" fill={AMBER} opacity="0.20" />

      {/* Puerta */}
      <rect x="246" y="148" width="16" height="28" rx="4" fill={AMBER} opacity="0.30" />
      <circle cx="254" cy="162" r="2" fill={AMBER} opacity="0.60" />

      {/* Ruedas */}
      <circle cx="162" cy="198" r="14" fill={BRAND} />
      <circle cx="162" cy="198" r="9"  fill="#f1f5f9" />
      <circle cx="162" cy="198" r="4"  fill={BRAND} />
      <circle cx="238" cy="198" r="14" fill={BRAND} />
      <circle cx="238" cy="198" r="9"  fill="#f1f5f9" />
      <circle cx="238" cy="198" r="4"  fill={BRAND} />

      {/* Parabrisas */}
      <rect x="130" y="126" width="24" height="30" rx="6" fill={AMBER} opacity="0.55" />

      {/* Signo de interrogación flotante — bus perdido */}
      <circle cx="316" cy="110" r="28" fill={BRAND} />
      <text x="316" y="119" textAnchor="middle"
        style={{ fontFamily: 'system-ui, sans-serif', fontWeight: 900, fontSize: 28, fill: AMBER }}>
        ?
      </text>

      {/* Puntos decorativos */}
      <circle cx="88"  cy="80"  r="7" fill={AMBER} opacity="0.40" />
      <circle cx="322" cy="244" r="9" fill={AMBER} opacity="0.25" />
      <circle cx="100" cy="252" r="5" fill={BRAND} opacity="0.10" />
      <circle cx="68"  cy="185" r="4" fill={AMBER} opacity="0.30" />
      <circle cx="348" cy="170" r="5" fill={BRAND} opacity="0.08" />

    </svg>
  );
}

// ── Component ─────────────────────────────────────────────────────────────────

export function NotFound() {
  const navigate = useNavigate();

  return (
    <AuthSplitLayout illustration={<LostBusIllustration />}>

      <AuthBadge>Error 404</AuthBadge>

      <div style={{
        display: 'inline-flex', alignItems: 'baseline', gap: '0.4rem',
        marginBottom: '0.5rem',
      }}>
        <span style={{
          fontSize: 'clamp(4rem, 8vw, 6rem)', fontWeight: 900,
          color: BRAND, letterSpacing: '-0.05em', lineHeight: 1,
        }}>
          404
        </span>
      </div>

      <h1 style={{
        margin: '0 0 0.6rem', fontWeight: 700,
        fontSize: 'clamp(1.3rem, 2vw, 1.6rem)',
        color: BRAND, letterSpacing: '-0.03em', lineHeight: 1.2,
      }}>
        Ruta no encontrada
      </h1>

      <AuthDesc>
        La página que buscas no existe o fue movida.
        Verifica la dirección o regresa al inicio.
      </AuthDesc>

      <AuthButton type="button" onClick={() => navigate('/dashboard')}>
        Volver al panel
      </AuthButton>

      <div style={{ textAlign: 'center', marginTop: '1.2rem' }}>
        <button
          type="button"
          onClick={() => window.history.back()}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            fontSize: '0.74rem', fontWeight: 600,
            color: BRAND, opacity: 0.55, textDecoration: 'none',
          }}
        >
          ← Regresar a la página anterior
        </button>
      </div>

    </AuthSplitLayout>
  );
}
